import { DiscountCouponMutation } from 'src/context/CheckoutProvider/CheckoutProvider.types';
import { queryClient } from 'src/context/QueryProvider/QueryClient';
import useDiscountCouponMutations from 'src/features/discountCoupons/presentation/hooks/useDiscountCouponMutations';

export const useCheckoutActions = () => {
  const { applyCouponToCartMutation, removeCouponFromCartMutation } =
    useDiscountCouponMutations();

  const applyCouponToCart: DiscountCouponMutation = ({ couponCode }, options) =>
    applyCouponToCartMutation.mutate(
      { couponCode },
      {
        ...options,
        onSuccess: (data, variables, context) => {
          options?.onSuccess?.(data, variables, context);
          queryClient.invalidateQueries({ queryKey: ['cart'] });
        },
        onError: (error, variables, context) => {
          options?.onError?.(error, variables, context);
        },
      }
    );

  const removeCouponFromCart: DiscountCouponMutation = (
    { couponCode },
    options
  ) =>
    removeCouponFromCartMutation.mutate(
      { couponCode },
      {
        ...options,
        onSuccess: (data, variables, context) => {
          options?.onSuccess?.(data, variables, context);
          queryClient.invalidateQueries({ queryKey: ['cart'] });
        },
        onError: (error, variables, context) => {
          options?.onError?.(error, variables, context);
        },
      }
    );

  return {
    applyCouponToCart,
    removeCouponFromCart,
  };
};
